import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8h16","key":"svg-0"}],["path",{"d":"M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z","key":"svg-1"}],["path",{"d":"M8 4v4","key":"svg-2"}]]

const IconBrowser = createReactComponent('outline', 'browser', 'Browser', __iconNode);

export default IconBrowser;